import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { initPWA } from './plugins/pwa.ts'

import App from './App.vue'
import router from './router/index.ts'
import { vuetify } from './plugins/vuetify.ts'
import { startOfflinePosRuntime } from './offline/startup.ts'
import { installSystemSettingSyncListener } from './shared/helpers/system-setting-sync.ts'
import { useSystemSettingStore } from './stores/system-setting.store.ts'

import '@/styles/main.css'
import '@/styles/vuetify.css'
import '@/styles/auth.css'
import '@/styles/vuetify-overrides.scss'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(vuetify)

const stopSystemSettingSyncListener = installSystemSettingSyncListener((settings) => {
  const systemSettingStore = useSystemSettingStore(pinia)
  systemSettingStore.applyToApp(settings)
})
import.meta.hot?.dispose(stopSystemSettingSyncListener)

const offlineRuntime = startOfflinePosRuntime(pinia, {
  onError: (error) => {
    if (import.meta.env.DEV) {
      console.warn('[offline-pos]', error)
    }
  },
})
initPWA()

void offlineRuntime.whenIdle().then(() => app.mount('#app'))
